/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                function fullScreenHeight() {
                    var screenHeight = $(window).outerHeight();
                    var p;
                    var heightToSet;
                    var container;

                    $(".fullScreenHeight").each(function () {
                        p = $(this);
                        var force = p.hasClass("force");
                        container = p.closest(".fullScreenHeightContainer");
                        $(this).outerHeight("auto");

                        if (p.hasClass("subtractFooter") || p.hasClass("subtractHeader")) {
                            // console.log(screenHeight);
                            //console.log(($("footer.content-info").outerHeight()));
                            var height = screenHeight;
                            if(p.hasClass("subtractFooter")) {
                             height = height - $("footer.content-info").outerHeight();
                             }
                             if(p.hasClass("subtractHeader")) {
                             height = height - 50;
                             }
                            //console.log(height);

                            heightToSet = height;
                        } else {
                            heightToSet = screenHeight;

                        }
                        if ($(this).outerHeight(true) < heightToSet) {

                            $(this).outerHeight(heightToSet);


                        }


                    });

                }

                function equalize() {
                    $(".equalizeContainer").each(function () {
                        console.log(this);
                        var maxHeight = 0;
                        var height;
                        var children = $(this).find(".equalize");
                        children.each(function () {
                            height = $(this).outerHeight();

                            maxHeight = (height > maxHeight) ? height : maxHeight;

                        });


                        console.log(maxHeight);

                        children.outerHeight(maxHeight);

                    });
                }

                function centerInScreen() {
                    var screenHeight = $(window).outerHeight();

                    $(".centerInDiv").each(function () {


                        if ($(this).outerHeight(true) < screenHeight) {
                            $(this).addClass("centerInDivActive");
                        } else {
                            $(this).removeClass("centerInDivActive");
                        }
                    });

                }
                function resize() {
                    fullScreenHeight();
                    centerInScreen();
                    equalize();
                }


                var ScrollableWindows = (function () {
                    var p = this;
                    p.screenYValues = [];
                    p.screens = $("section.page");
                    p.lastModifiedScreen;
                    var mobile = false;
                    p.screenHeight = 0;
                    p.init = function () {
                        p.afterResize();

                    };

                    function scrollImages() {

                        if (!mobile) {
                            var scrollTop = $(window).scrollTop();

                            var val = closest(p.screenYValues, scrollTop);
                            var index = p.screenYValues.indexOf(val);


                            var screen = $(p.screens[index]);

                            if (p.lastModifiedScreen && p.lastModifiedScreen !== screen) {
                                p.lastModifiedScreen.find(".page_image").css("transform", "");
                            }


                            p.lastModifiedScreen = screen;
                            var curScreenHeight = screen.outerHeight();

                            if (curScreenHeight > p.screenHeight) {
                                var maxOffset = curScreenHeight - p.screenHeight;

                                var offset = scrollTop - val;
                                offset = (maxOffset > offset) ? offset : maxOffset;


                                $(screen).find(".page_image").css('transform', 'translateY(' + offset + 'px)');

                            }

                        }
                    }

                    p.afterResize = function () {

                        mobile = window.outerWidth < 1012;

                        if (!mobile) {
                            p.screens.each(function (i, el) {
                                p.screenYValues[i] = $(this).offset().top;
                            });
                            p.screenHeight = $(window).outerHeight();

                            scrollImages();
                        } else {
                            $(".page_image").css("transform", "");
                        }

                    };
                    function closest(arr, closestTo) {

                        var closestnr = Math.min.apply(null, arr); //Get the highest number in arr in case it match nothing.

                        for (var i = 0; i < arr.length; i++) { //Loop the array
                            if (arr[i] <= closestTo && arr[i] > closestnr) closestnr = arr[i]; //Check if it's higher than your number, but lower than your closest value
                        }

                        return closestnr; // return the value
                    }



                    $(window).scroll(function () {
                        if (!mobile) {
                            scrollImages();
                        }
                    });
                    return p;
                })();

                $(window).resize(function () {
                    resize();
                    ScrollableWindows.afterResize();

                });
                resize();
                ScrollableWindows.afterResize();

                var navMain = $("#bs-example-navbar-collapse-1");
                navMain.on("click", "a", null, function () {
                    navMain.collapse('hide');
                });

                $('a[href*="#"]:not([href="#"])').click(function () {
                    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html, body').animate({
                                scrollTop: target.offset().top
                            }, 500);
                            return false;
                        }
                    }
                });

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        },
        'bestelformulier': {
            init: function () {
                initBestelformulier();

            }



        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);


    /*
    $.fn.bestelformulier = function (action, param) {

    var itemsContainer = this;
    function Item(element, title, postID, threshold, priceMachine, priceWithMachine, priceWithoutMachine, priceBaked) {
    var self = this;
    this.element = $(element);

    this.postId = postID;
    this.itemDoughPrice = 0;
    this.itemMachinePrice = 0;
    this.itemBakedPrice = 0;
    this.subTotal = 0;
    this.title = title;


    this.details = "";

    function calculateDoughPrice() {
    calculateBakedPrice();
    var doughPrice = (self.includeMachine) ? self.priceWithMachine : self.priceWithoutMachine;

    var machineSupplement = (self.includeMachine) ? ((itemsContainer.days - 1) * self.priceMachine) : 0;
    self.itemDoughPrice = (self.nDough * doughPrice) + machineSupplement;
    self.subTotal = self.itemDoughPrice + self.itemBakedPrice;

    if (self.nDough > 0) {
    self.details = "Deeg: " + self.nDough + " stuks.";
    } else {
    self.details = "";
    }


    if (self.includeMachine) {
    var dagExt = (itemsContainer.days > 1) ? "dagen" : "dag";
    self.details += " Inclusief machines: " + itemsContainer.days + " " + dagExt;
    }




    }

    function calculateMachinePrice() {
    calculateBakedPrice();
    self.itemMachinePrice = itemsContainer.days * self.nExtraMachines * self.priceMachine;
    self.subTotal = self.itemMachinePrice + self.itemBakedPrice;
    var dagExt = (itemsContainer.days > 1) ? "dagen" : "dag";
    if (self.nExtraMachines > 0) {
    self.details = self.nExtraMachines + " machines " + "(" + itemsContainer.days + " " + dagExt + ")";

    } else {
    self.details = "";
    }



    }

    function calculateBakedPrice() {
    self.itemBakedPrice = self.nBaked * self.priceBaked;


    }

    function printSubtotalPrice() {

    if (self.details.length > 0) {
    self.details += "<br /> ";
    }
    if (self.nBaked > 0) {
    self.details += "Gebakken: " + self.nBaked + " stuks. ";
    }
    console.log(self.subTotal);
    self.subTotalLabel.text(self.subTotal);
    }

    this.updatePrice = function () {
    console.log("updateprice");
    var showMachines = $(self.orderOption).filter(":checked").val() == "machines";


    if (showMachines) {
    calculateMachinePrice();

    } else {
    calculateDoughPrice();
    }
    printSubtotalPrice();
    }


    this.threshold = threshold;
    this.priceMachine = priceMachine;
    this.priceWithMachine = priceWithMachine;
    this.priceWithoutMachine = priceWithoutMachine;
    this.priceBaked = priceBaked;

    this.includeMachine = false;
    this.nIncludedMachines = 1;
    this.nDough = 0;
    this.nExtraMachines = 0;
    this.nBaked = 0;


    this.includeMachineCheckbox = $(element).find("input.includeMachines");
    this.nExtraMachinesInput = $(element).find("input.nExtraMachines");
    this.nDoughInput = $(element).find("input.nDough");
    this.includedMachinesCounterLabel = $(element).find("span.includedMachinesCounter");
    this.includedMachinesCounterPlural = $(element).find("span.includedMachinesCounterPlural");
    this.orderOption = $(element).find("input.orderOption");
    this.subTotalLabel = $(element).find("span.subTotal");
    this.nBakedInput = $(element).find("input.nBaked");

    function changeOrderSelect() {
    var showMachines = $(self.orderOption).filter(":checked").val() == "machines";

    self.nDoughInput.prop('disabled', showMachines);
    self.includeMachineCheckbox.prop('disabled', showMachines);
    self.nExtraMachinesInput.prop('disabled', !showMachines);
    if (showMachines) {
    calculateMachinePrice();

    } else {
    calculateDoughPrice();
    }
    itemsContainer.trigger("valuesUpdated");
    }

    $(this.includeMachineCheckbox).change(function () {
    self.includeMachine = $(this).prop("checked");
    calculateDoughPrice();
    itemsContainer.trigger("valuesUpdated");
    });



    $(this.nExtraMachinesInput).change(function () {
    self.nExtraMachines = parseInt($(this).val());

    calculateMachinePrice();
    itemsContainer.trigger("valuesUpdated");
    });

    $(this.nDoughInput).change(function () {
    self.nDough = parseInt($(this).val());
    self.nIncludedMachines = Math.ceil(self.nDough / self.threshold);
    // self.includedMachinesCounterLabel.text(self.nIncludedMachines);
    if (self.nIncludedMachines != 1) {
    self.includedMachinesCounterPlural.show();
    } else {
    self.includedMachinesCounterPlural.hide();
    }


    calculateDoughPrice();

    itemsContainer.trigger("valuesUpdated");
    });
    $(this.orderOption).change(function () {
    changeOrderSelect();

    });
    $(this.nBakedInput).change(function () {
    self.nBaked = parseInt($(this).val());

    itemsContainer.trigger("valuesUpdated");
    });

    changeOrderSelect();
    itemsContainer.trigger("valuesUpdated");
    }
    function calculateOverview() {
    var openOrders = [];
    var items = itemsContainer.items;
    $(items).each(function (i, item) {
    item.updatePrice();

    if (item.subTotal > 0) {
    openOrders.push(item);
    }
    });
    return openOrders;

    }




    if (typeof action == 'undefined') {




    itemsContainer.items = [];

    itemsContainer.days = 1;
    itemsContainer.grandTotal = 0;

    $(itemsContainer).on("valuesUpdated", function () {
    itemsContainer.grandTotal = 0;
    $(itemsContainer.items).each(function (i, item) {
    itemsContainer.grandTotal += parseFloat(item.subTotal);
    });

    });


    return this.each(function (i, item) {
    //  console.log(item);
    var element = $(item);
    var postID = element.data("postid");
    var threshold = element.data("threshold");
    var priceMachine = element.data("pricemachineperday");
    var priceWithMachine = element.data("pricewithmachine");
    var priceWithoutMachine = element.data("pricewithoutmachine");
    var priceBaked = element.data("pricebaked");
    var title = element.data("title");
    itemsContainer.items.push(new Item(element, title, postID, threshold, priceMachine, priceWithMachine, priceWithoutMachine, priceBaked));
    });
    } else if (action == "getOverview") {

    return calculateOverview();
    } else if (action == 'setDays') {
    console.log("days: " + param);
    itemsContainer.days = param;
    itemsContainer.trigger("valuesUpdated");




    } else {
    return this;
    }
    }




    */



})(jQuery);                                                                                                                                                                                                                                                          // Fully reference jQuery after this point.
